import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

// Create axios instance
const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('mytour_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('mytour_token');
      localStorage.removeItem('mytour_user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth API
export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  changePassword: (data) => api.post('/auth/change-password', data),
  getProfile: () => api.get('/auth/me'),
};

// Dropdown API
export const dropdownAPI = {
  getDistricts: () => api.get('/dropdown/districts'),
  getProjectSites: () => api.get('/dropdown/project-sites'),
  getVehicleTypes: () => api.get('/dropdown/vehicle-types'),
  getVehicleOwnership: () => api.get('/dropdown/vehicle-ownership'),
  getPersonTypes: () => api.get('/dropdown/person-types'),
  getClientSourcing: () => api.get('/dropdown/client-sourcing'),
  getPaymentModes: () => api.get('/dropdown/payment-modes'),
  getUserPositions: () => api.get('/dropdown/user-positions'),
};

// Claims API
export const claimsAPI = {
  create: (data) => api.post('/claims/advance', data),
  getMyClaims: () => api.get('/claims/advance/my'),
  getClaimDetail: (id) => api.get(`/claims/advance/${id}`),
  applyClaim: (id) => api.put(`/claims/advance/${id}/apply`),
  cancelClaim: (id) => api.put(`/claims/advance/${id}/cancel`),
  downloadPDF: (id) => api.get(`/claims/advance/${id}/pdf`, { responseType: 'blob' }),
};

// Approvals API
export const approvalsAPI = {
  getPending: () => api.get('/approvals/pending'),
  processApproval: (id, data) => api.put(`/approvals/${id}`, data),
};

// Payments API
export const paymentsAPI = {
  getPending: () => api.get('/payments/pending'),
  processPayment: (id, data) => api.put(`/payments/${id}`, data),
};

// Reports API
export const reportsAPI = {
  createDaily: (data) => api.post('/reports/daily', data),
  uploadPhotos: (id, formData) => api.post(`/reports/daily/${id}/photos`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  getMyReports: () => api.get('/reports/daily/my'),
  getFederationReports: () => api.get('/reports/daily/federation'),
};

// MIS API
export const misAPI = {
  getSummary: () => api.get('/mis/summary'),
  getClaims: (params) => api.get('/mis/claims', { params }),
};

// Seed API
export const seedAPI = {
  seedOrganization: () => api.post('/seed/organization'),
  seedDropdown: () => api.post('/seed/dropdown'),
};

export default api;
